export type CacheIntent = "shared" | "identified" | "dynamic"

export interface Identity {
  stable: Record<string, string>
  identifying: Record<string, string>
}

export const identityHeaders = (identity: Identity, intent: CacheIntent): Record<string, string> =>
  intent === "shared" ? identity.stable : { ...identity.stable, ...identity.identifying }
